import { SVGProps, cloneElement } from 'react';

import { AssetsLogoBrandV3 } from './logos-v3/assets-v3-logo-brand';
import { AssetsMarkBrandV3 } from './logos-v3/assets-v3-mark-brand';
import { AtlassianLogoBrandV3 } from './logos-v3/atlassian-v3-logo-brand';
import { AtlassianMarkBrandV3 } from './logos-v3/atlassian-v3-mark-brand';
import { BambooLogoBrandV3 } from './logos-v3/bamboo-v3-logo-brand';
import { BambooMarkBrandV3 } from './logos-v3/bamboo-v3-mark-brand';
import { BitbucketLogoBrandV3 } from './logos-v3/bitbucket-v3-logo-brand';
import { BitbucketMarkBrandV3 } from './logos-v3/bitbucket-v3-mark-brand';
import { CollectionProductLogoBrandV3 } from './logos-v3/collection-product-v3-logo-brand';
import { CollectionProductMarkBrandV3 } from './logos-v3/collection-product-v3-mark-brand';
import { CollectionServiceLogoBrandV3 } from './logos-v3/collection-service-v3-logo-brand';
import { CollectionServiceMarkBrandV3 } from './logos-v3/collection-service-v3-mark-brand';
import { CollectionSoftwareMarkBrandV3 } from './logos-v3/collection-software-v3-mark-brand';
import { CollectionStrategyMarkBrandV3 } from './logos-v3/collection-strategy-v3-mark-brand';
import { CollectionTeamworkLogoBrandV3 } from './logos-v3/collection-teamwork-v3-logo-brand';
import { CollectionTeamworkMarkBrandV3 } from './logos-v3/collection-teamwork-v3-mark-brand';
import { CompassLogoBrandV3 } from './logos-v3/compass-v3-logo-brand';
import { CompassMarkBrandV3 } from './logos-v3/compass-v3-mark-brand';
import { ConfluenceLogoBrandV3 } from './logos-v3/confluence-v3-logo-brand';
import { ConfluenceMarkBrandV3 } from './logos-v3/confluence-v3-mark-brand';
import { CrucibleLogoBrandV3 } from './logos-v3/crucible-v3-logo-brand';
import { CustomerServiceManagementLogoBrandV3 } from './logos-v3/customer-service-management-v3-logo-brand';
import { CustomerServiceManagementMarkBrandV3 } from './logos-v3/customer-service-management-v3-mark-brand';
import { DxMarkBrandV3 } from './logos-v3/dx-v3-mark-brand';
import { EnterpriseLogoBrandV3 } from './logos-v3/enterprise-v3-logo-brand';
import { FocusLogoBrandV3 } from './logos-v3/focus-v3-logo-brand';
import { FocusMarkBrandV3 } from './logos-v3/focus-v3-mark-brand';
import { FoundationLogoBrandV3 } from './logos-v3/foundation-v3-logo-brand';
import { GuardLogoBrandV3 } from './logos-v3/guard-v3-logo-brand';
import { GuardMarkBrandV3 } from './logos-v3/guard-v3-mark-brand';
import { JiraAlignLogoBrandV3 } from './logos-v3/jira-align-v3-logo-brand';
import { JiraAlignMarkBrandV3 } from './logos-v3/jira-align-v3-mark-brand';
import { JiraProductDiscoveryLogoBrandV3 } from './logos-v3/jira-product-discovery-v3-logo-brand';
import { JiraProductDiscoveryMarkBrandV3 } from './logos-v3/jira-product-discovery-v3-mark-brand';
import { JiraServiceManagementLogoBrandV3 } from './logos-v3/jira-service-management-v3-logo-brand';
import { JiraServiceManagementMarkBrandV3 } from './logos-v3/jira-service-management-v3-mark-brand';
import { JiraLogoBrandV3 } from './logos-v3/jira-v3-logo-brand';
import { JiraMarkBrandV3 } from './logos-v3/jira-v3-mark-brand';
import { LoomCharlieLogoBrandV3 } from './logos-v3/loom-charlie-v3-logo-brand';
import { LoomCircularLogoBrandV3 } from './logos-v3/loom-circular-v3-logo-brand';
import { LoomMarkBrandV3 } from './logos-v3/loom-v3-mark-brand';
import { OpsgenieMarkBrandV3 } from './logos-v3/opsgenie-v3-mark-brand';
import { PipelinesMarkBrandV3 } from './logos-v3/pipelines-v3-mark-brand';
import { RovoDevLogoBrandV3 } from './logos-v3/rovo-dev-v3-logo-brand';
import { RovoDevMarkBrandV3 } from './logos-v3/rovo-dev-v3-mark-brand';
import { RovoLogoBrandV3 } from './logos-v3/rovo-v3-logo-brand';
import { RovoMarkBrandV3 } from './logos-v3/rovo-v3-mark-brand';
import { SourcetreeLogoBrandV3 } from './logos-v3/sourcetree-v3-logo-brand';
import { SourcetreeMarkBrandV3 } from './logos-v3/sourcetree-v3-mark-brand';
import { StatuspageLogoBrandV3 } from './logos-v3/statuspage-v3-logo-brand';
import { StatuspageMarkBrandV3 } from './logos-v3/statuspage-v3-mark-brand';
import { TalentLogoBrandV3 } from './logos-v3/talent-v3-logo-brand';
import { TalentMarkBrandV3 } from './logos-v3/talent-v3-mark-brand';
import { TeamworkGraphMarkBrandV3 } from './logos-v3/teamwork-graph-v3-mark-brand';
import { TrelloLogoBrandV3 } from './logos-v3/trello-v3-logo-brand';
import { TrelloMarkBrandV3 } from './logos-v3/trello-v3-mark-brand';

export type LogoBrandV3 =
	| 'atlassian'
	| 'assets'
	| 'bamboo'
	| 'bitbucket'
	| 'collectionteamwork'
	| 'collectionservice'
	| 'collectionsoftware'
	| 'collectionstrategy'
	| 'collectionproduct'
	| 'compass'
	| 'confluence'
	| 'crucible'
	| 'customerservicemanagement'
	| 'dx'
	| 'enterprise'
	| 'pipelines'
	| 'focus'
	| 'foundation'
	| 'guard'
	| 'jira'
	| 'jirasoftware'
	| 'jiraalign'
	| 'jiraproductdiscovery'
	| 'jiraservicemanagement'
	| 'loom'
	| 'loomcircular'
	| 'opsgenie'
	| 'rovo'
	| 'rovodev'
	| 'sourcetree'
	| 'softwaredevelopment'
	| 'statuspage'
	| 'talent'
	| 'teamworkgraph'
	| 'trello';

export interface LogoPropsV3 extends Pick<SVGProps<SVGSVGElement>, 'height' | 'width'> {
	type: 'mark' | 'logo';
	appearance: 'brand';
	brand: LogoBrandV3;
	darkTheme?: boolean;
}

type LogoAppearance = {
	brand: JSX.Element;
};

type LogoType = {
	mark?: LogoAppearance;
	logo?: LogoAppearance;
};

type Logos = { [key in LogoBrandV3]: LogoType };

const Logos: Logos = {
	atlassian: {
		mark: {
			brand: <AtlassianMarkBrandV3 />,
		},
		logo: {
			brand: <AtlassianLogoBrandV3 />,
		},
	},
	assets: {
		mark: {
			brand: <AssetsMarkBrandV3 />,
		},
		logo: {
			brand: <AssetsLogoBrandV3 />,
		},
	},
	bamboo: {
		mark: {
			brand: <BambooMarkBrandV3 />,
		},
		logo: {
			brand: <BambooLogoBrandV3 />,
		},
	},
	bitbucket: {
		mark: {
			brand: <BitbucketMarkBrandV3 />,
		},
		logo: {
			brand: <BitbucketLogoBrandV3 />,
		},
	},
	collectionteamwork: {
		mark: {
			brand: <CollectionTeamworkMarkBrandV3 />,
		},
		logo: {
			brand: <CollectionTeamworkLogoBrandV3 />,
		},
	},
	collectionservice: {
		mark: {
			brand: <CollectionServiceMarkBrandV3 />,
		},
		logo: {
			brand: <CollectionServiceLogoBrandV3 />,
		},
	},
	collectionsoftware: {
		mark: {
			brand: <CollectionSoftwareMarkBrandV3 />,
		},
	},
	collectionstrategy: {
		mark: {
			brand: <CollectionStrategyMarkBrandV3 />,
		},
	},
	collectionproduct: {
		mark: {
			brand: <CollectionProductMarkBrandV3 />,
		},
		logo: {
			brand: <CollectionProductLogoBrandV3 />,
		},
	},
	compass: {
		mark: {
			brand: <CompassMarkBrandV3 />,
		},
		logo: {
			brand: <CompassLogoBrandV3 />,
		},
	},
	confluence: {
		mark: {
			brand: <ConfluenceMarkBrandV3 />,
		},
		logo: {
			brand: <ConfluenceLogoBrandV3 />,
		},
	},
	crucible: {
		logo: {
			brand: <CrucibleLogoBrandV3 />,
		},
	},
	customerservicemanagement: {
		mark: {
			brand: <CustomerServiceManagementMarkBrandV3 />,
		},
		logo: {
			brand: <CustomerServiceManagementLogoBrandV3 />,
		},
	},
	dx: {
		mark: {
			brand: <DxMarkBrandV3 />,
		},
	},
	enterprise: {
		logo: {
			brand: <EnterpriseLogoBrandV3 />,
		},
	},
	focus: {
		mark: {
			brand: <FocusMarkBrandV3 />,
		},
		logo: {
			brand: <FocusLogoBrandV3 />,
		},
	},
	foundation: {
		logo: {
			brand: <FoundationLogoBrandV3 />,
		},
	},
	guard: {
		mark: {
			brand: <GuardMarkBrandV3 />,
		},
		logo: {
			brand: <GuardLogoBrandV3 />,
		},
	},
	jira: {
		mark: {
			brand: <JiraMarkBrandV3 />,
		},
		logo: {
			brand: <JiraLogoBrandV3 />,
		},
	},
	jirasoftware: {
		mark: {
			brand: <JiraMarkBrandV3 />,
		},
		logo: {
			brand: <JiraLogoBrandV3 />,
		},
	},
	jiraalign: {
		mark: {
			brand: <JiraAlignMarkBrandV3 />,
		},
		logo: {
			brand: <JiraAlignLogoBrandV3 />,
		},
	},
	jiraproductdiscovery: {
		mark: {
			brand: <JiraProductDiscoveryMarkBrandV3 />,
		},
		logo: {
			brand: <JiraProductDiscoveryLogoBrandV3 />,
		},
	},
	jiraservicemanagement: {
		mark: {
			brand: <JiraServiceManagementMarkBrandV3 />,
		},
		logo: {
			brand: <JiraServiceManagementLogoBrandV3 />,
		},
	},
	loom: {
		mark: {
			brand: <LoomMarkBrandV3 />,
		},
		logo: {
			brand: <LoomCharlieLogoBrandV3 />,
		},
	},
	loomcircular: {
		mark: {
			brand: <LoomMarkBrandV3 />,
		},
		logo: {
			brand: <LoomCircularLogoBrandV3 />,
		},
	},
	opsgenie: {
		mark: {
			brand: <OpsgenieMarkBrandV3 />,
		},
	},
	pipelines: {
		mark: {
			brand: <PipelinesMarkBrandV3 />,
		},
	},
	rovo: {
		mark: {
			brand: <RovoMarkBrandV3 />,
		},
		logo: {
			brand: <RovoLogoBrandV3 />,
		},
	},
	rovodev: {
		mark: {
			brand: <RovoDevMarkBrandV3 />,
		},
		logo: {
			brand: <RovoDevLogoBrandV3 />,
		},
	},
	softwaredevelopment: {},
	sourcetree: {
		mark: {
			brand: <SourcetreeMarkBrandV3 />,
		},
		logo: {
			brand: <SourcetreeLogoBrandV3 />,
		},
	},
	statuspage: {
		mark: {
			brand: <StatuspageMarkBrandV3 />,
		},
		logo: {
			brand: <StatuspageLogoBrandV3 />,
		},
	},
	talent: {
		mark: {
			brand: <TalentMarkBrandV3 />,
		},
		logo: {
			brand: <TalentLogoBrandV3 />,
		},
	},
	teamworkgraph: {
		mark: {
			brand: <TeamworkGraphMarkBrandV3 />,
		},
	},
	trello: {
		mark: {
			brand: <TrelloMarkBrandV3 />,
		},
		logo: {
			brand: <TrelloLogoBrandV3 />,
		},
	},
};

export const LogoV3 = ({ brand, type, appearance, width, height, darkTheme }: LogoPropsV3) => {
	const logo = Logos[brand]?.[type]?.[appearance];

	return logo ? cloneElement(logo, { width, height, darkTheme }) : null;
};
